<section class="schedule-section-container">
	<div class="section-title">
		<div class="section-title-name">
			<p class="select-label" [class.error-title]="isInvalidDaysOfWeek">
				{{ 'schedule' | translate }}
			</p>
			<mat-icon
				class="tooltip"
				svgIcon="info"
				[matTooltip]="'action_center_actions_set_schedule' | translate"
				matTooltipClass="au-tooltip"
			/>
		</div>
		<div class="section-title-toggle">
			<p class="toggle-state">
				{{ formControlValue.scheduled ? ('on' | translate) : ('off' | translate) }}
			</p>
			<mat-slide-toggle
				[checked]="formControlValue.scheduled"
				(change)="toggleSchedule($event)"
				color="primary"
			></mat-slide-toggle>
		</div>
	</div>
	@if (formControlValue.scheduled) {
		<div class="section-content m-t-sm">
			<schedule-options
				[selectedOptions]="formControlValue"
				[selectedDaysError]="isInvalidDaysOfWeek"
				(optionsChanged)="scheduleOptionsChanged($event)"
				[useDebounce]="useDebounce"
			></schedule-options>
			@if (isInvalidDaysOfWeek) {
				<p class="section-error-hint">
					{{ 'please_select_at_least_one_day' | translate }}
				</p>
			}
		</div>
	}
</section>
